import { FC, useState } from "react";
import { TextInput } from "@datassential/platform-ui-lib";
import { IconClose } from "@icons";
import "./MenuTermsInput.styles.scss";

interface iProps {
    title: string;
    placeholder?: string;
    value: string[];
    onChange: (terms: string[]) => void;
    testId?: string;
}

const MenuTermsInput: FC<iProps> = (
    {
        title,
        placeholder = "",
        value,
        onChange,
        testId,
    }
) => {
    const [inputValue, setInputValue] = useState("");

    const addTerm = () => {
        const term = inputValue.trim();
        setInputValue("");
        if (!term) return;
        const isDuplicate = value.some(v => v.toLowerCase() === term.toLowerCase());
        if (isDuplicate) return;
        onChange([...value, term]);
    };

    const removeTerm = (term: string) => {
        onChange(value.filter(v => v !== term));
    };

    return (
        <div className="MenuTermsInput">
            <div className="MenuTermsInput__label">{title}</div>
            <TextInput
                value={inputValue}
                setValue={setInputValue}
                onSubmit={addTerm}
                placeholder={placeholder}
                testId={testId}
            />
            {value.length > 0 && (
                <div className="MenuTermsInput__tags">
                    {value.map(term => (
                        <div className="MenuTermsInput__tag" key={term}>
                            <span className="MenuTermsInput__tag-label">{term}</span>
                            <button
                                type="button"
                                className="MenuTermsInput__tag-remove"
                                onClick={() => removeTerm(term)}
                                aria-label={`Remove ${term}`}
                            >
                                <IconClose className="MenuTermsInput__tag-remove-icon" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MenuTermsInput;
